// Teklif Yonetimi ekraninin tasarim tokenlari.
//
// Renkler Arcelik temasindan (src/modules/theme/palette.js):
//   primary   #FF9800  Arcelik turuncusu  -> ana eylem
//   secondary #424242  koyu gri           -> notr eylem
//
// NOT: palette.js'te hem primary hem secondary icin contrastText turuncu
// tanimli. Bu yuzden MUI'nin color="primary" / color="secondary" prop'lari
// turuncu zemin uzerine turuncu yazi uretiyor. Renkler burada !important ile
// yerel olarak sabitleniyor. (Ayni yaklasim HVAC modulunde de kullanildi.)

export const C = {
  canvas: '#f1f5f9',
  surface: '#ffffff',
  headBg: '#f8fafc',
  rowAlt: '#fbfcfd',
  border: '#e2e8f0',
  borderSoft: '#eef2f7',
  ink: '#0f172a',
  inkStrong: '#1e293b',
  inkBody: '#334155',
  inkMuted: '#64748b',
  inkSoft: '#94a3b8'
};

export const BRAND = {
  main: '#FF9800',
  hover: '#F57C00',
  neutral: '#424242',
  neutralHover: '#616161',
  danger: '#d32f2f',
  dangerHover: '#b71c1c',
  disabledBg: 'rgba(15, 23, 42, 0.12)',
  disabledFg: 'rgba(15, 23, 42, 0.38)'
};

// ---------------------------------------------------------------- BUTONLAR
// Tum butonlar tek olcu: yukseklik 40, minWidth 120, radius 10.
const BUTTON_BASE = {
  height: 40,
  minWidth: 120,
  paddingLeft: '20px',
  paddingRight: '20px',
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.875rem',
  lineHeight: 1,
  boxShadow: 'none',
  whiteSpace: 'nowrap',
  '& .MuiButton-startIcon svg, & .MuiButton-endIcon svg': { fontSize: '1.125rem' }
};

const contained = (bg, bgHover, shadow) => ({
  ...BUTTON_BASE,
  backgroundColor: `${bg} !important`,
  color: '#ffffff !important',
  border: 'none !important',
  '&:hover': { backgroundColor: `${bgHover} !important`, boxShadow: shadow },
  '&.Mui-disabled': {
    backgroundColor: `${BRAND.disabledBg} !important`,
    color: `${BRAND.disabledFg} !important`,
    boxShadow: 'none'
  }
});

/** Ana eylem: Yeni Teklif / Kaydet / Gonder */
export const primaryButton = contained(
  BRAND.main,
  BRAND.hover,
  '0 6px 16px -6px rgba(255, 152, 0, 0.8)'
);

/** Notr eylem: Sorgula / Kapat */
export const neutralButton = contained(
  BRAND.neutral,
  BRAND.neutralHover,
  '0 6px 16px -6px rgba(15, 23, 42, 0.5)'
);

/** Yikici onay: Evet, Sil */
export const dangerButton = contained(
  BRAND.danger,
  BRAND.dangerHover,
  '0 6px 16px -6px rgba(211, 47, 47, 0.7)'
);

/** Vazgecme: Hayir / Vazgec */
export const cancelButton = {
  ...BUTTON_BASE,
  backgroundColor: 'transparent !important',
  color: `${C.inkMuted} !important`,
  border: `1px solid ${C.border} !important`,
  '&:hover': {
    backgroundColor: '#f1f5f9 !important',
    border: `1px solid #cbd5e1 !important`
  },
  '&.Mui-disabled': {
    color: `${BRAND.disabledFg} !important`,
    border: `1px solid ${C.border} !important`
  }
};

// ------------------------------------------------------------ SATIR IKONU
export const ACTION_TONES = {
  info: { fg: '#0284c7', bg: '#e0f2fe', hover: '#bae6fd' },
  edit: { fg: '#2563eb', bg: '#dbeafe', hover: '#bfdbfe' },
  success: { fg: '#059669', bg: '#d1fae5', hover: '#a7f3d0' },
  warn: { fg: '#d97706', bg: '#fef3c7', hover: '#fde68a' },
  danger: { fg: '#dc2626', bg: '#fee2e2', hover: '#fecaca' }
};

// sx nesneleri satir basina yeniden uretilmesin diye bir kez kuruluyor.
export const ACTION_SX = Object.keys(ACTION_TONES).reduce((acc, tone) => {
  const p = ACTION_TONES[tone];
  acc[tone] = {
    width: 36,
    height: 36,
    borderRadius: '10px',
    backgroundColor: p.bg,
    color: p.fg,
    transition: 'transform .15s ease, background-color .15s ease, box-shadow .15s ease',
    '&:hover': {
      backgroundColor: p.hover,
      transform: 'translateY(-1px)',
      boxShadow: `0 4px 10px -4px ${p.fg}b3`
    },
    '&.Mui-disabled': { backgroundColor: '#f1f5f9', color: '#cbd5e1' },
    '& .MuiSvgIcon-root': { fontSize: '1.15rem' }
  };
  return acc;
}, {});

// --------------------------------------------------------------- DURUMLAR
// Teklif durumlari. Renkler anlamla eslesir, her ekranda ayni.
export const DURUMLAR = {
  TASLAK: { kod: 1, etiket: 'Taslak', bg: '#f1f5f9', fg: '#475569' },
  GONDERILDI: { kod: 2, etiket: 'Gönderildi', bg: '#e0f2fe', fg: '#0369a1' },
  ONAYLANDI: { kod: 3, etiket: 'Onaylandı', bg: '#d1fae5', fg: '#065f46' },
  REDDEDILDI: { kod: 4, etiket: 'Reddedildi', bg: '#fee2e2', fg: '#991b1b' },
  SURESI_DOLDU: { kod: 5, etiket: 'Süresi Doldu', bg: '#fef3c7', fg: '#78350f' }
};

export const durumBilgisi = kod =>
  Object.values(DURUMLAR).find(d => d.kod === Number(kod)) || DURUMLAR.TASLAK;

export const durumChipSx = kod => {
  const d = durumBilgisi(kod);
  return {
    height: 24,
    borderRadius: '7px',
    fontSize: '0.75rem',
    fontWeight: 600,
    backgroundColor: d.bg,
    color: d.fg
  };
};

// ------------------------------------------------------------- YARDIMCILAR
export const paraFormatla = deger => {
  const sayi = Number(deger);
  if (Number.isNaN(sayi)) return '0 TL';
  return `${sayi.toLocaleString('tr-TR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })} TL`;
};

export const sayiyaCevir = deger => {
  const sayi = parseFloat(String(deger ?? '').replace(',', '.'));
  return Number.isNaN(sayi) ? 0 : sayi;
};
